import React from 'react';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import RaisedButton from '../../../../tc-ui/raised-button-with-loader';
import debounce from 'lodash.debounce';
import R from 'ramda';
import queryString from 'query-string';
import moment from 'moment';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
export default ({
  router,
  contractRequest,
  updateProps,
  sendContracts,
  message,
  subject,
  templateSelected,
  templateGroupSelected,
  contractsSent,
  bccSelf,
  tags,
  folders,
  sendingContracts,
  showReviewAndSendForResponseWizard,
  error,
  templates,
}) => {
  if (isNilOrEmpty(templates) || !contractRequest || R.isEmpty(contractRequest)) return <div/>;
  const partners = [{
    profileImageUrl: contractRequest.buyerProfileImageUrl,
    company_name: contractRequest.buyerName,
    companyId: contractRequest.buyerId,
  }];
  const handleActionButton = () => {
    return R.call(R.cond([
      [R.equals(true), () => {
        if (!subject) {
          updateProps({ error: 'Please enter a subject line.' });
          debounce(() => updateProps({ error: '' }), 4000)();
        } else {
          sendContracts({ templateSelected, templateGroupSelected, message, partners, subject, bccSelf, tags, folders });
        }
      }],
      [R.T, () => {
        if (isNilOrEmpty(templateSelected) && isNilOrEmpty(templateGroupSelected)) {
          updateProps({ error: 'Please select a template before proceeding.' });
          debounce(() => updateProps({ error: '' }), 4000)();
        } else {
          // updateProps({ showReviewAndSendForResponseWizard: true });
          window.location = `${
            process.env.NEW_SYSTEM_URL
          }/partner-management/send-assets?${queryString.stringify({
            partnerids: [contractRequest.partners[0].id],
            contactids: [contractRequest.contacts[0].id],
            go_back_to: window.location.href,
            ...(templateGroupSelected && templateGroupSelected._id
            ? { templategroupid: [templateGroupSelected._id] }
            : { templateids: [templateSelected._id] }),
            message,
            subject,
            // openpanel: 'message',
          })}&jwt=${localStorage.getItem('jwt')}`;
        }
      }],
    ]), showReviewAndSendForResponseWizard);
  };
  if (contractsSent) {
    return (<RaisedButton
      secondary
      style={{ margin: '24px 0 40px 40%' }}
      label="View Contracts"
      onTouchTap={() => router.push('/contracting/contract-list/all%20contracts')}
    />);
  }
  return (<div style={{ display: 'flex', justifyContent: 'space-between', margin: '16px' }}>
    <FlatButton
      label="exit"
      primary
      onTouchTap={() => router.push('/contracting/contract-list/recent')}
      labelStyle={{ fontWeight: '600' }}
    />
    <div style={{ color: 'red' }}>{error}</div>
    <div>
      {
        showReviewAndSendForResponseWizard ? (
          <FlatButton
            label="back"
            onTouchTap={() => updateProps({ showReviewAndSendForResponseWizard: false })}
          />
        ) : <div/>
      }
      <RaisedButton
        label="Continue"
        secondary
        loader={sendingContracts}
        labelStyle={{ fontWeight: '600' }}
        onTouchTap={handleActionButton}
      />
    </div>
  </div>);
};




// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/respond-contract-request/right-side/actionButtons.jsx